<template>
  <div class="student-detail-page">
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/studentList'}">在读学员</el-breadcrumb-item>
      <el-breadcrumb-item>学员详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="card-header">
        <span>学员基本信息</span>
        <el-button @click="resetForm" icon="el-icon-back" size="mini">返回列表</el-button>
      </div>
      <div>
        <el-form label-width="160px" ref="fromData" :model="fromData" >
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="学员姓名：" prop="realname">
                {{fromData.realname}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="就读学校：" prop="school">
                {{fromData.school}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年级：" prop="grade">
                {{gradeArr[fromData.grade]}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="手机号码：" prop="phone">
                {{fromData.phone}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="科目：" prop="subject">
                {{fromData.subject}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="性别：" prop="sex">
                {{fromData.sex==1?"男":fromData.sex==2?"女":"未填写"}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="学管师：" prop="teacherManagerName">
                {{fromData.teacherManagerName}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学员生日：" prop="birthday">
                {{fromData.birthday}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="家庭住址：" prop="homeAddress">
                {{fromData.homeAddress}}
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 👇 这一整行已按你要求重新排版 -->
          <el-row :gutter="24">
            <!-- 左侧：紧急联系人 -->
            <el-col :span="8">
              <el-form-item label="紧急联系人：" prop="emergencyContact">
                {{fromData.emergencyContact}}（{{fromData.emergencyContactPhone || '无'}}）
              </el-form-item>
            </el-col>

            <!-- 右侧：套餐剩余 + 赠送 合并一行 -->
            <el-col :span="16">
              <el-form-item label="套餐剩余：" prop="emergencyContactPhone">
                <div class="package-row">
                  <!-- 班课 -->
                  <div class="package-item">
                    <span class="tag tag-class">班课</span>
                    <span class="num">{{fromData.totalClassTimes}}次 {{fromData.totalClassHours}}小时</span>
                  </div>

                  <!-- 一对一 -->
                  <div class="package-item">
                    <span class="tag tag-one">一对一</span>
                    <span class="num">{{fromData.totalOneTimes}}次 {{fromData.totalOneHours}}小时</span>
                  </div>

                  <!-- 赠送 -->
                  <div class="package-item">
                    <span class="tag tag-give">赠送</span>
                    <span class="num">{{giveTimes}}次 +{{giveHours}}小时</span>
                  </div>

                  <!-- 赠送按钮 -->
                  <el-button size="mini" type="primary" @click="openGiveDialog" class="give-btn">
                    赠送
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>
    </el-card>

    <!-- 学员课程信息 - 带滚动条 -->
    <el-card class="mt20">
      <div slot="header" class="card-header">
        <span>学员课程信息</span>
      </div>
      <div class="table-wrapper course-table">
        <el-table
          :data="infoList"
          style="width: 100%"
          border
          size="medium"
          max-height="320">
          <el-table-column
            prop="className"
            label="班级名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="courseName"
            label="课程名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="courseTypeDesc"
            label="课程类型">
          </el-table-column>
          <el-table-column
            prop="setMealName"
            label="绑定套餐">
          </el-table-column>
          <el-table-column
            prop="times"
            label="上课次数">
          </el-table-column>
          <el-table-column
            prop="firstTime"
            label="开班日期">
          </el-table-column>
          <el-table-column
            prop="timeStr"
            label="上课时间">
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 学员套餐信息 - 带滚动条 -->
    <el-card class="mt20">
      <div slot="header" class="card-header">
        <span>学员套餐信息</span>
      </div>
      <div class="table-wrapper setmeal-table">
        <el-table
          :data="setMealLogList"
          style="width: 100%"
          border
          size="medium"
          max-height="360">
          <el-table-column property="setMealName" label="套餐名称" width="200">
          </el-table-column>
          <el-table-column label="套餐场景" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.classType==1?'一对一':'班课'}}</span>
            </template>
          </el-table-column>
          <el-table-column property="timesSnapshot" label="次数" width="100">
          </el-table-column>
          <el-table-column property="giveTimesSnapshot" label="赠送次数" width="150">
          </el-table-column>
          <el-table-column property="hoursSnapshot" label="小时数" width="150">
          </el-table-column>
          <el-table-column property="giveHoursSnapshot" label="赠送小时数" width="150">
          </el-table-column>
          <el-table-column property="price" label="套餐价格" width="150">
          </el-table-column>
          <el-table-column property="createTime" label="购买时间" width="150">
          </el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <el-button @click="handleDelete(scope.row)" type="text" style="color:#F53F3F">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 赠送弹窗组件 -->
    <el-dialog
      title="赠送套餐次数/小时"
      :visible.sync="giveDialogVisible"
      width="460px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="giveForm" label-width="100px" ref="giveFormRef">
        <el-form-item label="赠送次数" prop="giveTimes" :rules="[{ required: true, message: '请输入赠送次数', trigger: 'blur' }, { type: 'number', min: 0, message: '赠送次数不能为负数', trigger: 'blur' }]">
          <el-input v-model.number="giveForm.giveTimes" type="number" min="0" placeholder="请输入赠送次数"></el-input>
        </el-form-item>
        <el-form-item label="赠送小时" prop="giveHours" :rules="[{ required: true, message: '请输入赠送小时', trigger: 'blur' }, { type: 'number', min: 0, message: '赠送小时不能为负数', trigger: 'blur' }]">
          <el-input v-model.number="giveForm.giveHours" type="number" min="0" placeholder="请输入赠送小时"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeGiveDialog">取消</el-button>
        <el-button type="primary" @click="confirmGive">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id:'',
        fromData:{},
        gradeArr: ['', '', '二年级', '三年级', '四年级', '五年级', '六年级', '七年级', '八年级', '九年级', '高一', '高二', '高三'],
        infoList:[],
        setMealLogList:[],
        giveTimes: 0,
        giveHours: 0,
        giveDialogVisible: false,
        giveForm: {
          giveTimes: 0,
          giveHours: 0
        }
      };
    },
    created() {
      this.id = this.$route.query.id?this.$route.query.id:'';
      if(this.id){
        this.loadData();
      }
    },
    methods: {
      async loadData() {
        let data = { id:this.id }
        const { data: res } = await this.$http.post("/ea/student/student/queryById",data);
        if (res.code !== 200) return this.$message.error(res.message);
        this.fromData = res.result;
        this.infoList = res.result.courseDetailList;
        this.setMealLogList = res.result.setMealLogDetailList;
        this.giveTimes = res.result.giveTimes || 0;
        this.giveHours = res.result.giveHours || 0;

        console.log(this.fromData)
      },
      resetForm() {
        this.$router.push("/studentList");
      },
      openGiveDialog() {
        this.giveForm = { giveTimes: this.giveTimes, giveHours: this.giveHours };
        this.giveDialogVisible = true;
      },
      closeGiveDialog() {
        this.giveDialogVisible = false;
        this.$refs.giveFormRef && this.$refs.giveFormRef.clearValidate();
      },
      handleDelete(row) {
        this.$confirm('确认删除该套餐吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteStudentSetMealLog(row.id)
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' });
        });
      },
      async deleteStudentSetMealLog(id){
        let idModel = {
          id:id
        }
        const { data: res } = await this.$http.post(`/ea/student/student/deleteStudentSetMealLog`,idModel);
        if (res.code !== 200)
          return this.$message.error(res.message);
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        await this.loadData();
      },
      async confirmGive() {
        try { await this.$refs.giveFormRef.validate(); }
        catch (error) { return; }
        try {
          const { data: res } = await this.$http.post("/ea/student/student/giveSet", {
            id: this.id,
            giveTimes: this.giveForm.giveTimes,
            giveHours: this.giveForm.giveHours
          });
          if (res.code !== 200) { this.$message.error(res.message); return; }
          await this.loadData();
          this.$message.success(res.message || "赠送设置成功");
          this.giveDialogVisible = false;
        } catch (e) {
          this.$message.error("赠送请求失败，请重试！");
          console.error("赠送接口异常：", e);
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .student-detail-page {
    padding: 10px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 15px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .ml10 {
    margin-left: 10px;
  }

  /* 表格滚动容器 */
  .table-wrapper {
    width: 100%;
    overflow: hidden;
  }

  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }

  ::v-deep .el-upload__input{
    display: none;
  }

  /* 👇 套餐一行排版样式 */
  .package-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    .package-item {
      display: flex;
      align-items: center;
      gap: 6px;
      padding-right:10px;

      .tag {
        display: inline-block;
        padding: 1px 6px;
        border-radius: 3px;
        font-size: 12px;
        color: #fff;
        line-height: 1.4;
      }
      .tag-class {
        background-color: #409eff;
      }
      .tag-one {
        background-color: #67c23a;
      }
      .tag-give {
        background-color: #E6A23C;
      }

      .num {
        font-size: 14px;
        color: #303133;
        white-space: nowrap;
      }
    }

    .give-btn {
      margin-left: 4px;
    }
  }
</style>
